export default {
  serviceTemplates(state) {
    return state.serviceTemplates
  },

  serviceTemplate(state) {
    return state.serviceTemplate
  },

  serviceTemplatesFiltered(state) {
    return state.serviceTemplatesFiltered
  },

  getServiceTemplateById: state => id => _.find(state.serviceTemplates, template => template.id === id),
}
